import { FrontEndColumn } from '@app/shared/interfaces/front-end-column';
import {
  Component,
  OnInit,
  Injector,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { BaseComponent } from '../base-component/base-component.component';

@Component({
  selector: 'app-list-column-selector',
  templateUrl: './list-column-selector.component.html',
  styleUrls: ['./list-column-selector.component.less'],
})
export class ListColumnSelectorComponent
  extends BaseComponent
  implements OnInit
{
  @Input() columnsList: FrontEndColumn[] = [];
  @Input() visibleColumns: FrontEndColumn[] = [];
  @Output() visibleColumnsChange: EventEmitter<FrontEndColumn[]> =
    new EventEmitter();

  visibilityChangeCounter = 0;
  isVisible = false;
  searchValue = '';

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {}

  handleCancel() {
    this.isVisible = false;
  }

  SubmitColumns() {
    this.isVisible = false;
  }

  showModal() {
    this.isVisible = true;
  }

  search() {
    const searchValue = this.searchValue.toLowerCase();
    this.columnsList.forEach((c) => {
      if (c.label != null) {
        c.visibleInForSelection =
          c.label.toLowerCase().indexOf(searchValue) > -1 ||
          c.name.toLowerCase().indexOf(searchValue) > -1;
      } else {
        c.visibleInForSelection = c.name.indexOf(searchValue) > -1;
      }
    });
  }

  visibilityChanged() {
    const visibilityChangeCounter = this.visibilityChangeCounter + 1;
    this.visibilityChangeCounter = visibilityChangeCounter;

    setTimeout(() => {
      if (this.visibilityChangeCounter != visibilityChangeCounter) {
        return;
      }
      this.visibleColumns = this.columnsList.filter((c) => c.visible);
      this.visibleColumnsChange.emit(this.visibleColumns);
    }, 1000);
  }
}
